<template>
    <div>
        <vue-headful :title="'Dashboard - AMOS365'" />

        <div class="row">
            <div class="col-lg-8 col-12 mb-lg-0 mb-4">
                <div class="card mb-4">
                    <div class="card-header">
                        <b-form inline>
                            <label><strong>{{ comments.length }}</strong>&nbsp;Unread Comments From the Last:</label>
                            <b-form-input v-model="recent_comment_days" class="mb-2 mr-sm-2 mb-sm-0 ml-1" placeholder="Enter the Number of Prior Days to Pull Comments From" size="sm"></b-form-input>
                            <label>Days</label>

                            <button type="button" class="btn btn-sm btn-warning ml-3" v-on:click="refreshData()" :disabled="loading_comments"><i :class="{'fa fa-sync': true, 'fa-spin': loading_comments}"></i> Refresh</button>
                        </b-form>
                    </div>
                    <div class="card-body" style="max-height: 500px; overflow-y: auto">
                        <div v-if="comments.length === 0">
                            -- No Unread Comments Within the Last {{ recent_comment_days }} Days --
                        </div>
                        <template  v-for="(comment, i) in comments">
                            <hr v-if="i > 0" />

                            <div class="media mb-2">
                                <div class="media-body ml-4">
                                    <div class="row mb-1">
                                        <div class="col-md-6 col-12 mb-md-2 mb-0">
                                            <a href="javascript:void(0)">{{ comment.first_name }} {{ comment.last_name }}</a> on
                                            <span class="text-muted">{{ comment.created_at | moment('timezone', timezone, "MM/DD/YYYY hh:mm a") }}: </span>
                                            <router-link :to="$root.getUrl(comment)" :title="`View ${comment.record_type}`">{{ $root.getRecordName(comment) }}</router-link>
                                        </div>
                                        <div class="col-md-6 col-12 mb-md-2 mb-0">
                                            <div class="float-right">
                                                <button class="btn btn-xs btn-default" v-on:click="markRead(i, comment.id)" :disabled="read_comments[i]">
                                                    <i :class="{'fas': true, 'fa-check-square': !read_comments[i], 'fa-spinner fa-spin': read_comments[i]}"></i> Mark Read
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-2">{{ comment.comment_details }}</div>

                                    <a href="javascript:void(0)" v-if="!comment.readby" v-on:click="loadReadBy(i, comment.id)">View Read By</a>
                                    <div class="text-muted" v-else>
                                        Read By ({{ comment.readby.length }}):
                                        <span v-for="(user, j) in comment.readby">
                                            <span v-if="j > 0">, </span>
                                            <span :title="'Read At: '+user.read_at_formatted">{{ user.first_name }} {{ user.last_name }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>

                <div class="card mb-4" v-if="this.$root.hasPermission(['contracts.view', 'contracts.manage'])">
                    <div class="card-header">
                        <b-form inline>
                            <label><strong>{{ contracts.length }}</strong>&nbsp;Contracts Terminating +/- {{ recent_terminate_days }} Days From Now</label>
                            <b-form-input v-model="recent_terminate_days" class="mb-2 mr-sm-2 mb-sm-0 ml-1" placeholder="Enter the Number of Days" size="sm"></b-form-input>
                            <label>Days</label>

                            <button type="button" class="btn btn-sm btn-warning ml-3" v-on:click="refreshData()" :disabled="loading_comments"><i :class="{'fa fa-sync': true, 'fa-spin': loading_comments}"></i> Refresh</button>
                        </b-form>
                    </div>
                    <div class="card-body">
                        <v-client-table ref="dashContractsTable" :data="contracts" :columns="columns" :options="options">

                            <template slot="id" slot-scope="props">
                                <router-link :to="`/contracts/view/${props.row.id}`" title="View Contract" class="btn btn-sm btn-default">View</router-link>
                            </template>

                            <template slot="product_name" slot-scope="props">
                                <router-link :to="`/contracts/view/${props.row.id}`" title="View Contract" :class="{'text-muted': (props.row.is_active === 0)}">{{ props.row.product_name }}</router-link>
                            </template>

                            <template slot="agent_last_name" slot-scope="props">
                                <router-link :to="`/agents/view/${props.row.agent_id}`">{{ props.row.agent_last_name }}, {{ props.row.agent_first_name }}</router-link>
                            </template>

                            <template slot="client_last_name" slot-scope="props">
                                <router-link :to="`/clients/view/${props.row.client_id}`">{{ props.row.client_last_name }}, {{ props.row.client_first_name }}</router-link>
                            </template>

                            <template slot="writing_nbr" slot-scope="props">
                                <router-link :to="`/contracts/view/${props.row.id}`" title="View Contract">{{ props.row.writing_nbr }}</router-link>
                            </template>

                            <template slot="product_level_name" slot-scope="props">
                                <span v-if="props.row.product_level_name">
                                    {{ props.row.product_level_name }}
                                </span>
                                <span v-else-if="props.row.commission">
                                    <i class="fa fa-xs fa-flag text-warning text-muted" title="This is the Plain Text Commission Value from Legacy AMOS v1"></i> - {{ props.row.commission }}
                                </span>
                            </template>

                            <template slot="is_active" slot-scope="props">
                                <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                                <label class="badge badge-warning" v-else>Inactive</label>
                            </template>

                            <template slot="credentialing_date" slot-scope="props">
                                <span v-if="props.row.credentialing_date">{{ props.row.credentialing_date | moment("MM/DD/YYYY") }}</span>
                            </template>

                            <template slot="certification_date" slot-scope="props">
                                <span v-if="props.row.certification_date">{{ props.row.certification_date | moment("MM/DD/YYYY") }}</span>
                            </template>

                            <template slot="sent_date" slot-scope="props">
                                <span v-if="props.row.sent_date">{{ props.row.sent_date | moment("MM/DD/YYYY") }}</span>
                            </template>

                            <template slot="termination_date" slot-scope="props">
                                <span v-if="props.row.termination_date">{{ props.row.termination_date | moment("MM/DD/YYYY") }}</span>
                            </template>
                        </v-client-table>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-12">
                <div class="card mb-4">
                    <div class="card-header">Recently Viewed</div>
                    <div class="card-body">
                        <ul class="list-unstyled mb-0">
                            <li v-for="item in recent" :key="item.id" class="mb-2">
                                <router-link :to="$root.getUrl(item)" :title="`View ${item.record_type}`">
                                    <i class="fa fa-sm fa-building" v-if="item.record_type == 'Agency'"></i>
                                    <i class="fa fa-sm fa-users" v-if="item.record_type == 'Agent'"></i>
                                    <i class="fa fa-sm fa-shield-alt" v-if="item.record_type == 'Carrier'"></i>
                                    <i class="fa fa-sm fa-address-card" v-if="item.record_type == 'Client'"></i>
                                    <i class="fa fa-sm fa-file-contract" v-if="item.record_type == 'Policy'"></i>
                                    <i class="fa fa-sm fa-book" v-if="item.record_type == 'Product'"></i>
                                    <i class="fa fa-sm fa-wrench" v-if="item.record_type == 'ProductContract'"></i>

                                    <span v-if="item.record_type === 'Agent' || item.record_type === 'Client'">{{ item.record.first_name }} {{ item.record.last_name }}</span>
                                    <span v-else-if="item.record_type === 'ProductContract'">{{ item.record.writing_nbr ?? 'Contract '+item.record.id }}</span>
                                    <span v-else-if="item.record_type === 'Policy'">{{ item.record.policy_number ?? 'Policy '+item.record.id }}</span>
                                    <span v-else>{{ item.record[(item.record_type.toLowerCase()) + '_name'] }}</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">Saved Reports ({{ saved_reports.length }})</div>
                    <div class="card-body">
                        <ul class="list-unstyled mb-0">
                            <li v-for="report in saved_reports">
                                <router-link :to="`/reports/custom/${report.id}`" v-if="report.report_type === 'Custom'">{{ report.report_name }}</router-link>
                                <router-link :to="`/reports/downline/${report.id}`" v-if="report.report_type === 'Downline'">{{ report.report_name }}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                loading_comments: false,
                timezone: this.$root.timezone,
                dashboardTab: 'home',
                recent: [],
                saved_reports: [],
                comments: [],
                contracts: [],
                recent_comment_days: 30,
                recent_terminate_days: 30,
                read_comments: {},


                columns: [
                    'product_name',
                    'product_level_name',
                    'seller_name',
                    'manager_name',
                    //'commission',
                    'writing_nbr',
                    'is_active',
                    'credentialing_date',
                    'certification_date',
                    'sent_date',
                    'termination_date',
                ],

                options: {
                    //filterable: false,
                    headings: {
                        id: 'Actions',
                        product_name: 'Product',
                        product_level_name: 'Level',
                        seller_name: 'Seller',
                        manager_name: 'Manager',
                        commission: 'Commission',
                        writing_nbr: 'Writing#',
                        is_active: 'Active',
                        credentialing_date: 'Credentialing',
                        certification_date: 'Certification',
                        sent_date: 'Sent',
                        termination_date: 'Termination',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'product_contracts.updated_at',
                    },
                    texts:{
                        filterPlaceholder:"Search Contracts",
                    },
                },
            }
        },

        watch: {
            // recent_comment_days(newVal, oldVal){
            //     //Refresh the comments
            //     this.refreshData();
            // }
        },

        computed: {

        },

        methods: {

            getDashboard(){
                //Send it
                // Test comment1
                this.$http.get('/dashboard', {recent_comment_days: this.recent_comment_days, recent_terminate_days: this.recent_terminate_days})
                    .then(response => {
                        //Set the data
                        this.recent = response.data.recent;
                        this.saved_reports = response.data.reports;
                        this.comments = response.data.comments;
                        this.contracts = response.data.contracts;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            refreshData(){
                //Send it
                this.loading_comments = true;

                // Test comment1
                this.$http.get('/dashboard', {refresh: true, recent_comment_days: this.recent_comment_days, recent_terminate_days: this.recent_terminate_days})
                    .then(response => {
                        //Set the data
                        this.comments = response.data.comments;
                        this.contracts = response.data.contracts;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading_comments = false;
                    });
            },

            markRead(i, comment_id){
                //Send it
                //this.read_comments[i] = true;

                // Test comment1
                this.$http.post('/comments/read/'+comment_id)
                    .then(response => {
                        //Set the data
                        this.comments.splice(i, 1);
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading_comments = false;

                        //Send it
                        //delete this.read_comments[i];
                    });
            },

            loadReadBy(i, comment_id){
                //Loading

                //Get the read by
                this.$http.get('/comments/read-by/'+comment_id)
                    .then(response => {
                        //Set the data
                        this.comments[i].readby = response.data.users;

                        //Re-render
                        this.$forceUpdate();
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading_comments = false;
                    });
            },
        },

        mounted() {
            //get the customer?
            this.getDashboard();
        }
    }
</script>